export default {
  storeNamespace: 'reference',
  authFeature: 'reference',
  listRouteName: "ReferenceList",
  newRouteName: "ReferenceNew",
  editRouteName: "ReferenceEdit",
  detailRouteName: "ReferenceDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'ReferenceForm',
  csvExportFilenamePrefix: 'references',
  titleField: 'internal_code',
  showExtendedFilters: true,
  fields: [{
    name: 'internal_code',
    label: "Code interne",
    type: 'text',
    inForm: true,
    required: true,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'product_id',
    label: "Produit",
    type: 'chosen',
    inForm: true,
    required: true,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'product',
    label: "Produit",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: true,
    inDetail: true,
    detailLink: 'ProductDetail',
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? value.name : null
  },
  {
    // Une référence n'est rattachée qu'à un entrepôt : l'environnement de stockage se lit sur
    // son produit, par entrepôt (SFD Échanges et stockage 1.1). Saisi à la création seulement —
    // ensuite, la référence change d'entrepôt par un transfert ou la réception d'un retour.
    name: 'current_warehouse_id',
    label: "Entrepôt",
    type: 'select',
    inForm: true,
    inFormCondition: (form) => !form.id,
    required: true,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'supplier_id',
    label: "Fournisseur",
    type: 'chosen',
    inForm: true,
    required: true,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'supplier',
    label: "Fournisseur",
    type: 'select',
    inForm: false,
    inList: false,
    sortable: true,
    filterIn: true,
    inDetail: true,
    detailLink: 'CompanyDetail',
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? value.name : null
  },
  {
    name: 'brand',
    label: "Marque",
    type: 'text',
    inForm: true,
    required: true,
    inList: false,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'model',
    label: "Modèle",
    type: 'text',
    inForm: true,
    inList: false,
    sortable: true,
    filterIn: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'serial_number',
    label: "Numéro de série",
    type: 'text',
    inForm: true,
    inList: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'comment',
    label: "Commentaire",
    type: 'textarea',
    inForm: true,
    required: false,
    inList: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'purchase_date',
    label: "Date d'achat",
    type: 'date',
    inForm: true,
    required: true,
    inList: true,
    sortable: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'purchase_price',
    label: "Prix d'achat HT",
    type: 'number',
    step: 0.01,
    inForm: true,
    required: true,
    inList: false,
    inDetail: true,
    inPdfExport: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
  },
  {
    name: 'purchase_price',
    label: "Prix d'achat HT",
    type: 'number',
    inCsvExport: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
  },
  {
    name: 'order_number',
    label: "N° de commande",
    type: 'text',
    inForm: true,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
  },
  {
    name: 'status_slug',
    label: "Statut",
    type: 'select',
    inForm: true,
    required: true,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
  },
  {
    name: 'reception',
    label: "Date de remise en stock",
    type: 'text',
    inList: true,
    formatter: (context, value, item) => item.status.status_slug == 'reference-en-stock' && item.reference_logs && item.reference_logs.length && item.reference_logs.slice(-1)[0].start_date ? context.$moment(item.reference_logs.slice(-1)[0].start_date).format("DD-MM-YYYY") : null
  },
  {
    name: 'current_agency',
    label: "Agence courante",
    type: 'text',
    inList: true,
    inCsvExport: true,
    formatter: (context, value, item) => item.status.status_slug == 'reference-en-location' && item.reference_logs && item.reference_logs.length && item.reference_logs.slice(-1)[0].agency && item.reference_logs.slice(-1)[0].agency.number ? item.reference_logs.slice(-1)[0].agency.number : null
  },
  {
    name: 'current_business',
    label: "Affaire courante",
    type: 'text',
    inList: true,
    inCsvExport: true,
    formatter: (context, value, item) => item.status.status_slug == 'reference-en-location' && item.reference_logs && item.reference_logs.length && item.reference_logs.slice(-1)[0].business && item.reference_logs.slice(-1)[0].business.number ? item.reference_logs.slice(-1)[0].business.number : null
  },
  {
    name: 'current_user',
    label: "Utilisateur courant",
    type: 'text',
    inList: true,
    inCsvExport: true,
    formatter: (context, value, item) => item.status.status_slug == 'reference-en-location' && item.reference_logs && item.reference_logs.length && item.reference_logs.slice(-1)[0].employee && item.reference_logs.slice(-1)[0].employee.fullname ? item.reference_logs.slice(-1)[0].employee.fullname : null
  },
  {
    name: 'status',
    label: "Statut",
    type: 'select',
    inForm: false,
    inList: true,
    sortable: true,
    filterIn: false,
    tabFilter: true,
    key: 'status_slug',
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? value.name : null
  },
  {
    name: 'return_mode',
    label: "Transport",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: true,
    formatter: (context, value, item) => item.product && item.product.return_mode ? context.$store.getters['product/getReturnMode'](item.product.return_mode).text : null
  },
  {
    name: 'group_slug',
    label: "Service",
    type: 'select',
    inList: true,
    sortable: true,
    extendedFilter: true,
  },
  {
    name: 'equipment_group',
    label: "Famille",
    type: 'select',
    inList: true,
    extendedFilter: true,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    formatter: (context, value) => value ? value : null
  },
  {
    // INC-003 : filtre entrepôt (select dans "Plus d'options")
    name: 'warehouse',
    label: "Entrepôt",
    type: 'select',
    extendedFilter: true,
  },
  {
    // Entrepôt de rattachement de la référence (celui sous lequel la range le filtre
    // « Entrepôt »). Hors stock (en location, en maintenance, vendue…), le matériel n'y est
    // pas physiquement : on le précise avec le statut plutôt que de masquer l'entrepôt.
    name: 'current_warehouse',
    label: "Entrepôt",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: true,
    inCsvExport: false,
    inPdfExport: false,
    formatter: (context, value, item) => {
      if (!value) {
        return null;
      }
      const warehouse = value.internal_code || value.name;
      if (!item.status || item.status.status_slug == 'reference-en-stock') {
        return warehouse;
      }
      return `${warehouse} — ${(item.status.name || '').toLowerCase()}, pas physiquement dans l'entrepôt`;
    },
  },
  {
    // Filtre seul (pas de colonne) : origine de la référence, via product.from_mcs.
    name: 'from_mcs',
    label: "Origine",
    type: 'select',
    inForm: false,
    inList: false,
    inDetail: false,
    inCsvExport: false,
    inPdfExport: false,
    extendedFilter: true,
  },
  {
    name: 'group_slug',
    label: "Service",
    inCsvExport: true,
    formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
  },
  {
    name: 'first_maintenance_date',
    label: "Date de première maintenance",
    type: 'date',
    inForm: false,
    required: false,
    inList: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'last_maintenance_date',
    label: "Date de dèrnière maintenance",
    type: 'date',
    inForm: false,
    required: false,
    inList: false,
    inDetail: true,
    inCsvExport: true,
    inPdfExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
  },
  {
    name: 'total_rental_amount',
    label: "Montant total des location",
    type: 'number',
    step: 0.01,
    inForm: false,
    required: false,
    inList: false,
    inDetail: true,
    inPdfExport: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
  },
  {
    name: 'total_rental_days',
    label: "Nombre total de jours loué",
    type: 'number',
    inForm: false,
    required: false,
    inList: false,
    inDetail: true,
    inPdfExport: true,
  },
  {
    name: 'reference_total_cost',
    label: "Coup total",
    type: 'number',
    step: 0.01,
    inForm: false,
    required: false,
    inList: false,
    inDetail: true,
    inPdfExport: true,
    formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
  },
  {
    name: 'created_at',
    label: "Création",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: true,
    inPdfExport: false,
    formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inForm: false,
    inList: false,
    inDetail: true,
    inPdfExport: false,
    formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
  },
  {
    name: 'created_at',
    label: "Création",
    type: 'date',
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
  },
  {
    name: 'updated_at',
    label: "Dernière modification",
    type: 'date',
    inCsvExport: true,
    formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
  },
  ]
}



// WEBPACK FOOTER //
// ./src/components/Reference/config.js